<template>
  <modal 
    name="client-source-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'620px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        How did you acquire this client?
      </div>

      <a href="#"
        v-on:click.prevent="close"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">

      <div class="text-base">
        Add or update how you acquired this client. It will help you keep track of all your sources.
      </div>     

      <template v-if="clientSources != null && clientSources.length > 0">
        <div class="mt-6 text-sm">
          Select from sources previously added
        </div>

        <div class="form-line">
          <select v-model="clientSourceId" class="select-standard h-10">
            <option :value="null">Please select your source</option>
            <template v-for="(clientSource, index) in clientSources">
              <option :value="clientSource.id">{{ clientSource.first_name }} {{ clientSource.last_name }}</option>
            </template>
          </select>
        </div>

        <div class="label-line text-sm">
          Or add a new source below
        </div>
      </template>

      <div class="form-line">
        <select v-model="sourceType" class="select-standard h-10">
          <option :value="null">Please select a source type</option>
          <option value="friend">From a friend</option>
          <option value="family">Family</option>
          <option value="self">Self-sourced</option>
          <option value="financial-planner">Financial planner</option>
          <option value="accountant">Accountant</option>
          <option value="property-developer">Property developer</option>
          <option value="real-estate-agent">Real estate agent</option>
          <option value="client">Client</option>
          <option value="solicitor">Solicitor</option>
          <option value="other">Other</option>
        </select>
      </div>

      <template v-if="sourceType == 'other'">
        <div class="label-line text-sm">
          Please describe your source
        </div>

        <div class="form-line">
          <input type="text" class="input-standard" v-model="sourceTypeOther" />
        </div>
      </template>

      <template v-if="sourceType != null && sourceType != 'self'">
        <div class="label-line flex flex-wrap">
          <div class="w-1/2 pr-4">
            <div class="text-sm">
              First name
            </div>

            <div class="form-line">
              <input type="text" class="input-standard" v-model="firstName" />
            </div>
          </div>

          <div class="w-1/2 pl-4">
            <div class="text-sm">
              Last name
            </div>

            <div class="form-line">
              <input type="text" class="input-standard" v-model="lastName" />
            </div>
          </div>
        </div>

        <div class="label-line text-sm">
          Email
        </div>

        <div class="form-line">
          <input type="text" class="input-standard" v-model="email" />
        </div>

        <div class="label-line text-sm">
          Mobile
        </div>

        <div class="form-line">
          <input type="text" class="input-standard" v-model="mobile" />
        </div>
      </template>


      <div class="button-line" v-if="(clientSources != null && clientSources.length > 0) || sourceType != null">
        <SubmitButton2 :onClick="submit" :loading="loading" label="Submit" />
      </div>

      <div class="mt-4" v-if="applicantId != null">
        <a href="#" 
          class="text-gray-700 hover:underline" 
          @click.prevent="goToClient">Skip</a>
      </div>

    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        loading        : false,
        clientSourceId : null,
        firstName      : null,
        lastName       : null,
        email          : null,
        mobile         : null,
        sourceType     : null,
        sourceTypeOther: null,
        client         : null,
        applicantId    : null,
        clientSources  : null,
      }
    },

    methods : {
      
      beforeOpen(event) {
        this.loading         = false
        this.clientSourceId  = event.params.client.client_source_id 
        this.firstName       = null
        this.lastName        = null
        this.email           = null
        this.mobile          = null
        this.sourceType      = null
        this.sourceTypeOther = null
        this.client          = event.params.client
        this.applicantId     = event.params.applicantId

        this.apiGet({}, 'client-source/data', (clientSources) => {
          this.clientSources = clientSources
        })
      },

      opened(event) {
        // close this modal, if it's open
        this.$modal.hide('add-client-modal')
      },

      close() {
        this.$modal.hide('client-source-modal')

        if(this.applicantId) {
          this.goToClient()
        }
      },

      goToClient() {
        this.$modal.hide('client-source-modal')
        this.$router.push({
          name  : 'application-applicant-profile',
          params: {
            clientId   : this.client.id,
            applicantId: this.applicantId
          }
        })
      },

      submit() {
        let valid = true
        
        if(valid) {
          this.loading = true
          this.apiPost({
            clientSourceId : this.clientSourceId,
            firstName      : this.firstName,
            lastName       : this.lastName,
            email          : this.email,
            mobile         : this.mobile,
            sourceType     : this.sourceType,
            sourceTypeOther: this.sourceTypeOther,
            clientId       : this.client.id
          }, 'client-source/create', () => {
            this.loading = false
            this.$modal.hide('client-source-modal')
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Client source saved."
            })

            this.close()
          })
        }
      }
    }
  }
</script>